import { render, staticRenderFns } from "./VehiclePreview.vue?vue&type=template&id=2da8c791&"
import script from "./VehiclePreview.vue?vue&type=script&lang=js&"
export * from "./VehiclePreview.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports